@if (!sideNavHide) {
<div>
  @if (!this.schoolProps.properties.job_only_school && this.schoolProps.properties.user_type != 'Group' &&
  this.schoolProps.properties.user_type != 'GroupCoordinator' && this.schoolProps.properties.user_type != 'Tracer')
  {
  <div>
    <div id="mySidenav" class="sidenav" [ngClass]="{
      'sidenav-hide': collapsed || hideNavOnJobs,
      'sidenav-show': !collapsed || !hideNavOnJobs
    }">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <!-- <img alt="" class="side_logo_text" src="assets/images/side-nav/cc_original@2x.png"> -->
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <button class="logo" (click)="toggleCollapsed()">
              <i class="bi bi-chevron-double-left"></i>
            </button>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- End of Dashboard -->
          <!-- Booking -->
          <!-- {{permissionService.hasAnyPermission(PERMISSION_GROUPS.BOOKING_FULL_ACCESS)}} -->
          @if (!this.hideSideMenu) {
          <a class="sidenav-nav-item" [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'"
            *ngIf="permissionService.hasAnyPermission(PERMISSION_GROUPS.BOOKING_FULL_ACCESS)">
            <button class="sidenav-nav-link accordion-button" (click)="is_booking_collapsed()" aria-label="Bookings"
              id="" [attr.aria-expanded]="is_booking_open" routerLinkActive="active-submenu"
              [routerLinkActiveOptions]="{ exact: true }"
              [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'" aria-controls="">
              <span><i class="sidenav-icon bi bi-calendar2-event"></i></span>
              <span class="sidanav-label"> Booking</span>
            </button>
            @if (is_booking_open) {
            <ul id="" class="submenu" aria-labelledby="" data-bs-parent="">
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.BOOKING.CREATE)">
                <a routerLink="/school/bookings/booking-request" aria-label="Booking Request" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaBookingReq="routerLinkActive"
                  [attr.aria-current]="rlaBookingReq.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Booking Request</span>
                </a>
              </li>
              <li class="sidenav-nav-item"
                *ngIf="permissionService.hasPermission(PERMISSIONS.PRECONFIRM_BOOKING.CREATE)">
                <a routerLink="/school/bookings/preconfirm-booking" aria-label="Pre-Confirmed Booking"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link"
                  #rlaPreconfirm="routerLinkActive" [attr.aria-current]="rlaPreconfirm.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Pre-Confirmed Booking</span>
                </a>
              </li>
              @if(schoolProps.properties.is_qld_school){
              <!-- <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.CIRCUIT_BOOKING.CREATE)">
                  <a routerLink="/school/bookings/circuit-booking" aria-label="Circuit Booking"
                    routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link"
                    #rlaPreconfirm="routerLinkActive" [attr.aria-current]="rlaPreconfirm.isActive ? 'page' : null">
                    <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                    <span class="sidanav-label">Circuit Booking</span>
                  </a>
                </li>               -->
              <li class="sidenav-nav-item"
                *ngIf="permissionService.hasPermission(PERMISSIONS.BOOKING_CONFIRMATION.CREATE)">
                <a routerLink="/school/bookings/booking-confirmation" aria-label="Booking Confirmation"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link"
                  #rlaPreconfirm="routerLinkActive" [attr.aria-current]="rlaPreconfirm.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Booking Confirmation</span>
                </a>
              </li>
              }
            </ul>
            }
          </a>
          }
          <!-- End of Booking -->
          <!-- Calendar -->
          @if (!this.hideSideMenu && this.schoolProps.properties.is_hub_school &&
          permissionService.hasPermission(PERMISSIONS.HUB_AND_SPOKE.VIEW)) {
          <li aria-label="Hub and Spoke" class="sidenav-nav-item">
            <a routerLink="/school/hub-spoke" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-diagram-2"></i></span>
              <span class="sidanav-label">Hub and Spoke</span>
              <span class="sidanav-collapsed-label">Hub and Spoke</span>
            </a>
          </li>
          }
          <!-- End of Calendar -->
          <!-- My List -->
          @if (!this.hideSideMenu && permissionService.hasAnyPermission(PERMISSION_GROUPS.MANAGE)) {
          <li class="sidenav-nav-item" routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }">
            <button class="sidenav-nav-link accordion-button" aria-label="Manage" (click)="is_manage_collapsed()" id=""
              [attr.aria-expanded]="is_manage_open" [ngClass]="is_manage_open ? 'tab-not-collapsed' : 'tab-collapsed'">
              <span><i class="sidenav-icon bi bi-people"></i></span>
              <span class="sidanav-label">Manage</span>
              <span class="sidanav-collapsed-label">Manage</span>
            </button>
            @if (is_manage_open) {
            <ul id="" class="submenu" aria-labelledby="" data-bs-parent="">
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.MY_LIST.VIEW)">
                <a routerLinkActive="active" aria-label="My List" routerLink="/school/manage/my-list"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaMyList="routerLinkActive"
                  [attr.aria-current]="rlaMyList.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-people"></i>
                  <span class="sidanav-label">My List</span>
                  <span class="sidanav-collapsed-label" data-bs-toggle="tooltip" data-bs-placement="right"
                    title="Tooltip on right">My List</span>
                </a>
              </li>
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.SMART_GROUPS.VIEW)">
                <a routerLink="/school/manage/smart-groups" aria-label="Smart Groups" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link"
                  #rlaSmartGroups="routerLinkActive" [attr.aria-current]="rlaSmartGroups.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-people"></i>
                  <span class="sidanav-label">Smart Groups</span>
                  <span class="sidanav-collapsed-label">Smart Groups</span>
                </a>
              </li>
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.INVITE.VIEW)">
                <a routerLink="/school/manage/pending-invites" aria-label="Invites" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaInvites="routerLinkActive"
                  [attr.aria-current]="rlaInvites.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-people"></i>
                  <span class="sidanav-label">Invites</span>
                  <span class="sidanav-collapsed-label">Invites</span>
                </a>
              </li>
            </ul>
            }
          </li>
          }
          <!-- End of My List -->
          <!-- Discover -->
          @if (!this.hideSideMenu && permissionService.hasAnyPermission(PERMISSION_GROUPS.DISCOVER)) {
          <li class="sidenav-nav-item" routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }">
            <button class="sidenav-nav-link accordion-button" aria-label="Discover" id=""
              (click)="is_discover_collapsed()" [ngClass]="is_discover_open ? 'tab-not-collapsed' : 'tab-collapsed'"
              aria-controls="" [attr.aria-expanded]="is_discover_open">
              <span><i class="sidenav-icon bi bi-person-check"></i></span>
              <span class="sidanav-label">Discover</span>
              <span class="sidanav-collapsed-label">Discover</span>
            </button>
            @if (is_discover_open) {
            <ul>
              @if (!schoolProps.properties.is_classroom_teacher) {
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.FIND_NEW_TEACHER.VIEW)">
                <a routerLink="/school/discover/find-new" aria-label="Find New" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaFindNew="routerLinkActive"
                  [attr.aria-current]="rlaFindNew.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-person-check"></i>
                  <span class="sidanav-label">Find New</span>
                  <span class="sidanav-collapsed-label">Find New</span>
                </a>
              </li>
              }
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.REQUEST.VIEW)">
                <a routerLink="/school/discover/pending-request" aria-label="Pending Requests" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaRequests="routerLinkActive"
                  [attr.aria-current]="rlaRequests.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-person-check"></i>
                  <span class="sidanav-label">Requests</span>
                  <span class="sidanav-collapsed-label">Requests</span>
                </a>
              </li>
            </ul>
            }
          </li>
          }
          <!-- End of Discover -->
          <!-- Calendar -->
          @if (!this.hideSideMenu) {
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.CALENDAR.VIEW)">
            <a routerLink="/school/calendar" aria-label="Calendar" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaCalendar="routerLinkActive"
              [attr.aria-current]="rlaCalendar.isActive ? 'page' : null">
              <span><i class="sidenav-icon bi bi-calendar2-check"></i></span>
              <span class="sidanav-label">Calendar</span>
              <span class="sidanav-collapsed-label">Calendar</span>
            </a>
          </li>
          }
          <!-- End of Calendar -->
          <!-- Jobs -->
          <!-- <li class="sidenav-nav-item" *ngIf="schoolProps.properties.is_qld_school && schoolProps.properties.is_parent_school">
            <a routerLink="/school/manage-schools" aria-label="Manage Schools" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaManageSchools="routerLinkActive"
              [attr.aria-current]="rlaManageSchools.isActive ? 'page' : null">
              <span><i class="sidenav-icon bi bi-bank"></i></span>
              <span class="sidanav-label">Manage schools</span>
              <span class="sidanav-collapsed-label">Manage schools</span>
            </a>
          </li> -->
          <!-- End of Jobs -->
          <!-- Jobs -->
          <li class="sidenav-nav-item" (click)="switchToJobs()" appFocus appClick
            *ngIf="!schoolProps.properties.is_qld_school">
            <a class="sidenav-nav-link" aria-label="Jobs">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
              <span class="sidanav-label">Jobs</span>
              <span class="sidanav-collapsed-label">Jobs</span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Booking History -->
          @if (!this.hideSideMenu && permissionService.hasPermission(PERMISSIONS.BOOKING_HISTORY.VIEW)) {
          <li class="sidenav-nav-item">
            <a routerLink="/school/bookings/history" aria-label="Booking History" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaBookingHistory="routerLinkActive"
              [attr.aria-current]="rlaBookingHistory.isActive ? 'page' : null">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
              <span class="sidanav-label">Booking History</span>
              <span class="sidanav-collapsed-label">Booking History</span>
            </a>
          </li>
          }
          <!-- End of Booking History -->
          <!-- Discover -->
          @if (!this.hideSideMenu && !hideForClassroomLimited &&
          permissionService.hasAnyPermission(PERMISSION_GROUPS.REPORTS)){
          <li class="sidenav-nav-item" routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }"
            *ngIf="permissionService.hasAnyPermission([PERMISSIONS.INSIGHTS.VIEW, PERMISSIONS.PAYROLL_REPORT.VIEW])">
            <button class="sidenav-nav-link accordion-button" aria-label="Reports" id=""
              (click)="is_reports_collapsed()" [ngClass]="is_reports_open ? 'tab-not-collapsed' : 'tab-collapsed'"
              aria-controls="" [attr.aria-expanded]="is_reports_open">
              <span><i class="sidenav-icon bi bi-bar-chart"></i></span>
              <span class="sidanav-label">Reports</span>
              <span class="sidanav-collapsed-label">Reports</span>
            </button>
            @if (is_reports_open) {
            <ul id="" class="submenu" aria-labelledby="">
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.INSIGHTS.VIEW)">
                <a routerLink="/school/reports/insights-report" aria-label="Insights" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaInsights="routerLinkActive"
                  [attr.aria-current]="rlaInsights.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-bar-chart"></i>
                  <span class="sidanav-label">Insights</span>
                  <span class="sidanav-collapsed-label">Insights</span>
                </a>
              </li>
              <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.PAYROLL_REPORT.VIEW)">
                <a routerLink="/school/reports/payroll-report" aria-label="Payroll Report" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaPayroll="routerLinkActive"
                  [attr.aria-current]="rlaPayroll.isActive ? 'page' : null">
                  <i class="sidenav-collapsed-icon bi bi-bar-chart"></i>
                  <span class="sidanav-label">Payroll report </span>
                  <span class="sidanav-collapsed-label">Payroll report </span>
                </a>
              </li>
            </ul>
            }
          </li>
          }
          <!-- End of Discover -->
          <!-- Reports -->
          <!-- <li class="sidenav-nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bar-chart"></i></span>
              <span class="sidanav-label">Reports</span>
              <span class="sidanav-collapsed-label">Reports</span>
            </a>
          </li> -->
          <!-- End of Reports -->
          <!-- Notification -->
          <!-- <li class="sidenav-nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bell"></i></span>
              <span class="sidanav-label">Notification</span>
              <span class="sidanav-collapsed-label">Notification</span>
            </a>
          </li> -->
          <!-- End of Notification -->
          <!-- Profile Settings -->
          <!-- <li class="sidenav-nav-item">
          <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            class="sidenav-nav-link">
            <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
            <span class="sidanav-label">Profile Settings</span>
            <span class="sidanav-collapsed-label">Profile Settings</span>
          </a>
        </li> -->
          <!-- End of Profile Settings -->
          <!-- Admin Settings -->
          <!-- <li class="sidenav-nav-item">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="sidenav-nav-link">
          <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
          <span class="sidanav-label">Admin Settings</span>
          <span class="sidanav-collapsed-label">Admin Settings</span>
        </a>
      </li> -->
          <!-- End of Admin Settings -->
          <!-- Additional Users -->
          <!-- <li class="sidenav-nav-item">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        class="sidenav-nav-link">
        <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
        <span class="sidanav-label">Additional Users</span>
        <span class="sidanav-collapsed-label">Additional Users</span>
      </a>
    </li> -->
          <!-- End of Additional Users -->
          <!-- Canny -->
          <!-- <li class="sidenav-nav-item">
              <a routerLink="/school/feedback" aria-label="Feedback" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link" #rlaFeedback="routerLinkActive"
                [attr.aria-current]="rlaFeedback.isActive ? 'page' : null">
                <span><i class="sidenav-icon bi bi-clipboard2-data"></i></span>
                <span class="sidanav-label">Feedback</span>
                <span class="sidanav-collapsed-label">Feedback</span>
              </a>
            </li> -->
          <!-- End of Canny -->
          <!-- Logout -->
          <li class="sidenav-nav-item">
            <a routerLink="" routerLinkActive="active" (click)="logout()" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-box-arrow-in-right"></i></span>
              <span class="sidanav-label">Logout</span>
              <span class="sidanav-collapsed-label">Logout</span>
            </a>
          </li>
          <!-- End of Logout -->
          <div class="bottom-sidenav">
            <li class="sidenav-nav-item">
              <a routerLink="/school/feedback" aria-label="Feedback" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link clr-cc-vilot"
                #rlaFeedback="routerLinkActive" [attr.aria-current]="rlaFeedback.isActive ? 'page' : null">
                <span> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" fill="#3A0CA3" stroke="#3A0CA3
" stroke-width="1" class="bi bi-exclamation-square" viewBox="0 0 16 20">
                    <path
                      d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                    <path
                      d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                  </svg></span>
                <span class="sidanav-label">Vote for features</span>
                <span class="sidanav-collapsed-label">Vote for features</span>
              </a>
            </li>
          </div>
        </div>

      </ul>
    </div>
    <div id="" class="sidenav-res" [ngClass]="collapsed ? 'sidenav-show' : 'sidenav-hide'">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <a class="logo" (click)="toggleCollapsed()"><i class="bi bi-chevron-double-left"></i>
            </a>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Booking -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasAnyPermission(PERMISSION_GROUPS.BOOKING_FULL_ACCESS)"
            [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'">
            <a class="sidenav-nav-link accordion-button" (click)="is_booking_collapsed()" id="" aria-expanded="false"
              [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'" aria-controls="">
              <span><i class="sidenav-icon bi bi-calendar2-event"></i></span>
            </a>
          </li>
          <!-- End of Booking -->
          <!-- Hub and spoke -->
          <li class="sidenav-nav-item" *ngIf="!schoolProps.properties.is_qld_school">
            <a routerLink="/school/hub-spoke" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-diagram-2"></i></span>
            </a>
          </li>
          <!-- End  Hub and spoke -->
          <!-- My List -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasAnyPermission(PERMISSION_GROUPS.MANAGE)"
            routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }">
            <a class="sidenav-nav-link accordion-button" (click)="is_manage_collapsed()" id=""
              [ngClass]="is_manage_open ? 'tab-not-collapsed' : 'tab-collapsed'">
              <span><i class="sidenav-icon bi bi-people"></i></span>
            </a>
          </li>
          <!-- End of My List -->
          <!-- Discover -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasAnyPermission(PERMISSION_GROUPS.DISCOVER)"
            routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }">
            <a class="sidenav-nav-link accordion-button" id="" (click)="is_discover_collapsed()"
              [ngClass]="is_discover_open ? 'tab-not-collapsed' : 'tab-collapsed'" aria-controls="">
              <span><i class="sidenav-icon bi bi-person-check"></i></span>
            </a>
          </li>
          <!-- End of Discover -->
          <!-- Calendar -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.CALENDAR.VIEW)">
            <a routerLink="/school/calendar" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-calendar2-check"></i></span>
            </a>
          </li>
          <!-- End of Calendar -->
          <!-- Jobs -->
          <li class="sidenav-nav-item" *ngIf="!schoolProps.properties.is_qld_school">
            <a routerLink="/school/jobs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Booking History -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS.BOOKING_HISTORY.VIEW)">
            <a routerLink="/school/bookings/history" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
            </a>
          </li>
          <!-- End of Booking History -->
          <!-- Reports -->
          <!-- <li class="sidenav-nav-item">
    <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
      class="sidenav-nav-link">
      <span><i class="sidenav-icon bi bi-bar-chart"></i></span>
      <span class="sidanav-label">Reports</span>
      <span class="sidanav-collapsed-label">Reports</span>
    </a>
  </li> -->
          <!-- End of Reports -->
          <!-- Notification -->
          <!-- <li class="sidenav-nav-item">
    <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
      class="sidenav-nav-link">
      <span><i class="sidenav-icon bi bi-bell"></i></span>
      <span class="sidanav-label">Notification</span>
      <span class="sidanav-collapsed-label">Notification</span>
    </a>
  </li> -->
          <!-- End of Notification -->
          <!-- Profile Settings -->
          <!-- <li class="sidenav-nav-item">
  <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
    class="sidenav-nav-link">
    <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
    <span class="sidanav-label">Profile Settings</span>
    <span class="sidanav-collapsed-label">Profile Settings</span>
  </a>
</li> -->
          <!-- End of Profile Settings -->
          <!-- Admin Settings -->
          <!-- <li class="sidenav-nav-item">
<a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
  class="sidenav-nav-link">
  <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
  <span class="sidanav-label">Admin Settings</span>
  <span class="sidanav-collapsed-label">Admin Settings</span>
</a>
</li> -->
          <!-- End of Admin Settings -->
          <!-- Additional Users -->
          <!-- <li class="sidenav-nav-item">
<a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
  class="sidenav-nav-link">
  <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
  <span class="sidanav-label">Additional Users</span>
  <span class="sidanav-collapsed-label">Additional Users</span>
</a>
</li> -->
          <!-- End of Additional Users -->
          <!-- Logout -->
          <li class="sidenav-nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-box-arrow-in-right"></i></span>
            </a>
          </li>
          <!-- End of Logout -->
          <div class="bottom-sidenav">
            <li class="sidenav-nav-item">
              <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" fill="#3A0CA3" stroke="#3A0CA3
" stroke-width="1" class="bi bi-exclamation-square" viewBox="0 0 16 20">
                    <path
                      d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                    <path
                      d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                  </svg>
                </span>
              </a>
            </li>
          </div>
        </div>
      </ul>
    </div>
  </div>
  }@else if(this.schoolProps.properties.user_type == 'Group') {
  <div>
    <div id="mySidenav" class="sidenav" [ngClass]="{
      'sidenav-hide': collapsed || hideNavOnJobs,
      'sidenav-show': !collapsed || !hideNavOnJobs
    }">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <!-- <img alt="" class="side_logo_text" src="assets/images/side-nav/cc_original@2x.png"> -->
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <button class="logo" (click)="toggleCollapsed()">
              <i class="bi bi-chevron-double-left"></i>
            </button>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Dashboard -->
          <li class="sidenav-nav-item">
            <a routerLink="/group" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-menu-button" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Dashboard</span>
              <div class="sidanav-collapsed-label">Dashboard</div>
            </a>
          </li>
          <!-- End of Dashboard -->
          <!-- Schools -->
          <li class="sidenav-nav-item">
            <a routerLink="/group/school" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-menu-button" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Schools</span>
              <div class="sidanav-collapsed-label">Schools</div>
            </a>
          </li>
          <!-- End of Schools -->
          <!-- Booking -->
          @if (!this.hideSideMenu) {
          <a class="sidenav-nav-item" [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'">
            <button class="sidenav-nav-link accordion-button" (click)="is_booking_collapsed()" aria-label="Teachers"
              id="" aria-expanded="false" routerLinkActive="active-submenu" [routerLinkActiveOptions]="{ exact: true }"
              [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'" aria-controls="">
              <span><i class="sidenav-icon bi bi-calendar2-event"></i></span>
              <span class="sidanav-label"> Teachers</span>
            </button>
            @if (is_booking_open) {
            <ul id="" class="submenu" aria-labelledby="" data-bs-parent="">
              <li class="sidenav-nav-item">
                <a routerLink="/group/all-teachers" aria-label="Pending Approvals" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">All teachers</span>
                </a>
              </li>
              <li class="sidenav-nav-item">
                <a routerLink="/group/pending-approvals" aria-label="Pending Approvals" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Pending approvals</span>
                </a>
              </li>
              <li class="sidenav-nav-item">
                <a routerLink="/group/pending-request" aria-label="Pending Approvals" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Pending request</span>
                </a>
              </li>
              <!-- <li class="sidenav-nav-item">
                <a routerLink="/group/lapsed-approvals" aria-label="Lapsed Approvals"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Lapsed approvals</span>
                </a>
              </li> -->
              @if(group_name === 'Catholic Diocese Wagga Wagga' || group_name === 'Diocese of Maitland-Newcastle'){
              <li class="sidenav-nav-item">
                <a routerLink="/group/bookings-report" aria-label="Bookings report" routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Bookings report</span>
                </a>
              </li>
              }
              <!-- <li class="sidenav-nav-item">
                <a routerLink="/group/teacher-custom-fields" aria-label="Teacher Custom Fields"
                  routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                  <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                  <span class="sidanav-label">Teacher custom fields</span>
                </a>
              </li> -->
            </ul>
            }
          </a>
          }
          <!-- End of Booking -->
          <!-- End of Discover -->
          <!-- Reports -->
          <!-- <li class="sidenav-nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bar-chart"></i></span>
              <span class="sidanav-label">Reports</span>
              <span class="sidanav-collapsed-label">Reports</span>
            </a>
          </li> -->
          <!-- End of Reports -->
          <div class="bottom-sidenav">
            <!-- Notification -->
            <!-- <li class="sidenav-nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bell"></i></span>
              <span class="sidanav-label">Notification</span>
              <span class="sidanav-collapsed-label">Notification</span>
            </a>
          </li> -->
            <!-- End of Notification -->
            <!-- Profile Settings -->
            <!-- <li class="sidenav-nav-item">
          <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
            class="sidenav-nav-link">
            <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
            <span class="sidanav-label">Profile Settings</span>
            <span class="sidanav-collapsed-label">Profile Settings</span>
          </a>
        </li> -->
            <!-- End of Profile Settings -->
            <!-- Admin Settings -->
            <!-- <li class="sidenav-nav-item">
        <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
          class="sidenav-nav-link">
          <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
          <span class="sidanav-label">Admin Settings</span>
          <span class="sidanav-collapsed-label">Admin Settings</span>
        </a>
      </li> -->
            <!-- End of Admin Settings -->
            <!-- Additional Users -->
            <!-- <li class="sidenav-nav-item">
      <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
        class="sidenav-nav-link">
        <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
        <span class="sidanav-label">Additional Users</span>
        <span class="sidanav-collapsed-label">Additional Users</span>
      </a>
    </li> -->
            <!-- End of Additional Users -->
            <!-- Logout -->
            <li class="sidenav-nav-item">
              <a routerLink="" routerLinkActive="active" (click)="logout()" [routerLinkActiveOptions]="{ exact: true }"
                class="sidenav-nav-link">
                <span><i class="sidenav-icon bi bi-box-arrow-in-right"></i></span>
                <span class="sidanav-label">Logout</span>
                <span class="sidanav-collapsed-label">Logout</span>
              </a>
            </li>
            <!-- End of Logout -->
          </div>
        </div>
      </ul>
    </div>
    <div id="" class="sidenav-res" [ngClass]="collapsed ? 'sidenav-show' : 'sidenav-hide'">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <a class="logo" (click)="toggleCollapsed()"><i class="bi bi-chevron-double-left"></i>
            </a>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Booking -->
          <li class="sidenav-nav-item" [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'">
            <a class="sidenav-nav-link accordion-button" (click)="is_booking_collapsed()" id="" aria-expanded="false"
              [ngClass]="is_booking_open ? 'tab-not-collapsed' : 'tab-collapsed'" aria-controls="">
              <span><i class="sidenav-icon bi bi-calendar2-event"></i></span>
            </a>
          </li>
          <!-- End of Booking -->
          <!-- Jobs -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Booking History -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/bookings/history" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
            </a>
          </li>
          <!-- End of Booking History -->
          <!-- Reports -->
          <!-- <li class="sidenav-nav-item">
    <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
      class="sidenav-nav-link">
      <span><i class="sidenav-icon bi bi-bar-chart"></i></span>
      <span class="sidanav-label">Reports</span>
      <span class="sidanav-collapsed-label">Reports</span>
    </a>
  </li> -->
          <!-- End of Reports -->
          <div class="bottom-sidenav">
            <!-- Notification -->
            <!-- <li class="sidenav-nav-item">
    <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
      class="sidenav-nav-link">
      <span><i class="sidenav-icon bi bi-bell"></i></span>
      <span class="sidanav-label">Notification</span>
      <span class="sidanav-collapsed-label">Notification</span>
    </a>
  </li> -->
            <!-- End of Notification -->
            <!-- Profile Settings -->
            <!-- <li class="sidenav-nav-item">
  <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
    class="sidenav-nav-link">
    <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
    <span class="sidanav-label">Profile Settings</span>
    <span class="sidanav-collapsed-label">Profile Settings</span>
  </a>
</li> -->
            <!-- End of Profile Settings -->
            <!-- Admin Settings -->
            <!-- <li class="sidenav-nav-item">
<a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
  class="sidenav-nav-link">
  <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
  <span class="sidanav-label">Admin Settings</span>
  <span class="sidanav-collapsed-label">Admin Settings</span>
</a>
</li> -->
            <!-- End of Admin Settings -->
            <!-- Additional Users -->
            <!-- <li class="sidenav-nav-item">
<a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
  class="sidenav-nav-link">
  <span><i class="sidenav-icon bi bi-graph-up-arrow"></i></span>
  <span class="sidanav-label">Additional Users</span>
  <span class="sidanav-collapsed-label">Additional Users</span>
</a>
</li> -->
            <!-- End of Additional Users -->
            <!-- Logout -->
            <li class="sidenav-nav-item">
              <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
                <span><i class="sidenav-icon bi bi-box-arrow-in-right"></i></span>
              </a>
            </li>
            <!-- End of Logout -->
          </div>
        </div>
      </ul>
    </div>
  </div>
  }@else if(this.schoolProps.properties.user_type == 'GroupCoordinator') {
  <div>
    <div id="mySidenav" class="sidenav" [ngClass]="{
      'sidenav-hide': collapsed || hideNavOnJobs,
      'sidenav-show': !collapsed || !hideNavOnJobs
    }">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <!-- <img alt="" class="side_logo_text" src="assets/images/side-nav/cc_original@2x.png"> -->
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <button class="logo" (click)="toggleCollapsed()">
              <i class="bi bi-chevron-double-left"></i>
            </button>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Dashboard -->
          <li class="sidenav-nav-item">
            <a routerLink="/co-ordinator" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-menu-button" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Dashboard</span>
              <div class="sidanav-collapsed-label">Dashboard</div>
            </a>
          </li>
          <!-- End of Dashboard -->
          <!-- Schools -->
          <li class="sidenav-nav-item">
            <a routerLink="/co-ordinator/my-schools" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bank" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">My Schools</span>
              <div class="sidanav-collapsed-label">My Schools</div>
            </a>
          </li>
          <!-- End of Schools -->
          <!-- Bookings -->
          <li class="sidenav-nav-item">
            <a routerLink="/co-ordinator/bookings" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-calendar2-event" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Bookings</span>
              <div class="sidanav-collapsed-label">Bookings</div>
            </a>
          </li>
          <!-- End of Bookings -->
          <!-- Teachers -->
          <li class="sidenav-nav-item">
            <a routerLink="/co-ordinator/teachers" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-people" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Teachers</span>
              <div class="sidanav-collapsed-label">Teachers</div>
            </a>
          </li>
          <!-- End of Teachers -->
          <!-- Calendar -->
          <li class="sidenav-nav-item">
            <a routerLink="/co-ordinator/calendar" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-calendar2-check" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Calendar</span>
              <div class="sidanav-collapsed-label">Calendar</div>
            </a>
          </li>
          <!-- End of Calendar -->
        </div>
      </ul>
    </div>
    <div id="" class="sidenav-res" [ngClass]="collapsed ? 'sidenav-show' : 'sidenav-hide'">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <a class="logo" (click)="toggleCollapsed()"><i class="bi bi-chevron-double-left"></i>
            </a>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Booking -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
            </a>
          </li>
          <!-- End of Booking -->
          <!-- Jobs -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Booking History -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/bookings/history" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
            </a>
          </li>
          <!-- Booking History -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/bookings/history" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
            </a>
          </li>
          <!-- Booking History -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/bookings/history" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
            </a>
          </li>
        </div>
      </ul>
    </div>
  </div>
  }@else if(this.schoolProps.properties.user_type == 'Tracer') {
  <div *ngIf="permissionService.hasAnyPermission(PERMISSION_GROUPS_TRACER.ALL)">
    <div id="mySidenav" class="sidenav" [ngClass]="{
      'sidenav-hide': collapsed || hideNavOnJobs,
      'sidenav-show': !collapsed || !hideNavOnJobs
    }">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <!-- <img alt="" class="side_logo_text" src="assets/images/side-nav/cc_original@2x.png"> -->
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <button class="logo" (click)="toggleCollapsed()">
              <i class="bi bi-chevron-double-left"></i>
            </button>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Bookings -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.BOOKINGS.VIEW)">
            <a routerLink="/tracer/bookings" routerLinkActive="activenav" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-menu-button" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Bookings</span>
              <div class="sidanav-collapsed-label">Bookings</div>
            </a>
          </li>
          <!-- End of Bookings -->
          <!-- Relief Employee Profiles -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.REP.VIEW)">
            <a routerLink="/tracer" routerLinkActive="activenav" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-people" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Relief Employee Profiles</span>
              <div class="sidanav-collapsed-label">Relief Employee Profiles</div>
            </a>
          </li>
          <!-- Leave Approval -->
          <!-- <li class="sidenav-nav-item">
            <a routerLink="/tracer/leave-approval" routerLinkActive="activenav"
              [routerLinkActiveOptions]="{exact: true}" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bank" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Leave Approval</span>
              <div class="sidanav-collapsed-label">Leave Approval</div>
            </a>
          </li> -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.MANAGE_TEAM.VIEW)">
            <a routerLink="/tracer/manage-team" routerLinkActive="activenav" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-person-gear" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Manage Team</span>
              <div class="sidanav-collapsed-label">Manage Team</div>
            </a>
          </li>
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.MY_SCHOOLS.VIEW)">
            <a routerLink="/tracer/my-schools" routerLinkActive="activenav" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bank" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">My Schools</span>
              <div class="sidanav-collapsed-label">My Schools</div>
            </a>
          </li>
          <!-- Calendar -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.TRACER_CALENDAR.VIEW)">
            <a routerLink="/tracer/calendar" routerLinkActive="activenav" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-calendar" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Calendar</span>
              <div class="sidanav-collapsed-label">Calendar</div>
            </a>
          </li>
          <li class="sidenav-nav-item">
            <a routerLink="/tracer/payroll-report" routerLinkActive="activenav"
              [routerLinkActiveOptions]="{exact: true}" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bank" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Payroll Report</span>
              <div class="sidanav-collapsed-label">Payroll Report</div>
            </a>
          </li>
          <li class="sidenav-nav-item">
            <a routerLink="/tracer/reports" routerLinkActive="activenav" [routerLinkActiveOptions]="{exact: true}"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon  bi bi-bar-chart" data-bs-toggle="tooltip" data-bs-placement="right"
                  title="Tooltip on right"></i></span>
              <span class="sidanav-label">Reports</span>
              <div class="sidanav-collapsed-label">Reports</div>
            </a>
          </li>
        </div>
      </ul>
    </div>
    <div id="" class="sidenav-res" [ngClass]="collapsed ? 'sidenav-show' : 'sidenav-hide'">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <a class="logo" (click)="toggleCollapsed()"><i class="bi bi-chevron-double-left"></i>
            </a>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Booking -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.BOOKINGS.VIEW)">
            <a routerLink="/tracer/bookings" routerLinkActive="activenav" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-menu-button"></i></span>
            </a>
          </li>
          <!-- End of Booking -->
          <!-- Jobs -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.REP.VIEW)">
            <a routerLink="/tracer" routerLinkActive="activenav" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bank"></i></span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Booking History -->
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.MANAGE_TEAM.VIEW)">
            <a routerLink="/tracer/manage-team" routerLinkActive="activenav" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-people"></i></span>
            </a>
          </li>
          <li class="sidenav-nav-item" *ngIf="permissionService.hasPermission(PERMISSIONS_TRACER.MY_SCHOOLS.VIEW)">
            <a routerLink="/tracer/my-schools" routerLinkActive="activenav" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-bi bi-people"></i></span>
            </a>
          </li>

        </div>
      </ul>
    </div>
  </div>
  }
  <div class="">
    @if (!hideNavOnJobs) {
    <button class="btn_res" (click)="toggleCollapsed()">
      <i class="bi bi-list"></i>
    </button>
    }
  </div>
  @if (this.schoolProps.properties.job_only_school) {
  <div [ngClass]="{ '': this.schoolProps.properties.job_only_school }">
    <div id="mySidenav" class="sidenav" [ngClass]="{
        'sidenav-hide': collapsed || hideNavOnJobs,
        'sidenav-show': !collapsed || !hideNavOnJobs
      }">
      <ul class="sidenav-nav">
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <li class="sidenav-nav-item">
            <!-- <img alt="" class="side__jobs_logo" src="assets/images/side-nav/CC _Jobs.png"> -->
            <div class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
              <button class="logo" (click)="toggleCollapsed()">
                <i class="bi bi-chevron-double-left"></i>
              </button>
            </div>
          </li>
          <!-- <li *ngIf="!this.hideSideMenu" class="sidenav-nav-item"
          [ngClass]="is_booking_open ? 'tab-not-collapsed': 'tab-collapsed'">
          <a [ngClass]="makeJobsActive ? 'active-submenu' : ''" class="sidenav-nav-link accordion-button"
            (click)="is_booking_collapsed()" id="" aria-expanded="false" aria-controls="">
            <span><i class="sidenav-icon bi bi-calendar2-event"></i></span>
            <span class="sidanav-label">Jobs</span>
          </a>
          <ul id="" class="submenu" *ngIf="is_booking_open" aria-labelledby="" data-bs-parent="">
            <li class="sidenav-nav-item jobs-tab">
              <a routerLink="/school/jobs" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}" class="sidenav-nav-link">
                <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                <span class="sidanav-label">Job listing</span>
              </a>
            </li>
            <li class="sidenav-nav-item jobs-tab">
              <a routerLink="/school/headhunter" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}" class="sidenav-nav-link">
                <i class="sidenav-collapsed-icon bi bi-calendar2-event"></i>
                <span class="sidanav-label">Headhunter: Find & Invite</span>
              </a>
            </li>
          </ul>
        </li> -->
          <!-- Jobs -->
          @if (!this.hideSideMenu) {
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
              <span class="sidanav-label">Jobs</span>
              <span class="sidanav-collapsed-label">Jobs</span>
            </a>
          </li>
          }
          <!-- End of Jobs -->
          <!-- headhunter -->
          @if (!this.hideSideMenu) {
          <li class="sidenav-nav-item">
            <a routerLinkActive="active" (click)="refershHeadhunter()" routerLink="/school/jobs/headhunter"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-people"></i></span>
              <span class="sidanav-label">Headhunter</span>
              <span class="sidanav-collapsed-label">Headhunter</span>
            </a>
          </li>
          }
          <!-- End of headhunter -->
          <!-- Switch to bookings school -->
          <!-- <li class="sidenav-nav-item" *ngIf="this.schoolProps.properties.job_only_school  && this.schoolProps.properties.is_booking_school">
        <a href="https://booking.classcover.com.au/"
          class="sidenav-nav-link">
          <span><i class="sidenav-icon bi bi-people"></i></span>
          <span class="sidanav-label">Switch to bookings school</span>
          <span class="sidanav-collapsed-label">Switch to bookings school</span>
        </a>
      </li> -->
          <!-- End of Switch to bookings school -->
          <!-- Jobs -->
          <li class="sidenav-nav-item">
            <a routerLinkActive="active" routerLink="/school/jobs/job-payment-history"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
              <span class="sidanav-label">Payment history</span>
              <span class="sidanav-collapsed-label">Payment history</span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Jobs -->
          @if (!this.schoolProps.properties.is_booking_school) {
          <li class="sidenav-nav-item">
            <a routerLinkActive="active" routerLink="/school/jobs/job-subscription"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link">
              <span><i class="sidenav-icon bi bi-gem"></i></span>
              <span class="sidanav-label">Upgrade your account</span>
              <span class="sidanav-collapsed-label">Upgrade your account</span>
            </a>
          </li>
          }
          <!-- End of Jobs -->
          <!-- Jobs -->
          <!-- <li class="sidenav-nav-item">
      <a routerLinkActive="active" routerLink="/school/edit-admin-settings/additional-users"
        [routerLinkActiveOptions]="{exact: true}" class="sidenav-nav-link">
        <span><i class="sidenav-icon bi  bi-clock-history"></i></span>
        <span class="sidanav-label">Manage team</span>
        <span class="sidanav-collapsed-label">Manage team</span>
      </a>
    </li> -->
          <!-- End of Logout -->
          <div class="bottom-sidenav">
            <li class="sidenav-nav-item">
              <a routerLink="/school/feedback" aria-label="Feedback" routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link clr-cc-vilot"
                #rlaFeedback="routerLinkActive" [attr.aria-current]="rlaFeedback.isActive ? 'page' : null">
                <span> <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" fill="#3A0CA3" stroke="#3A0CA3
" stroke-width="1" class="bi bi-exclamation-square" viewBox="0 0 16 20">
                    <path
                      d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                    <path
                      d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                  </svg></span>
                <span class="sidanav-label">Vote for features</span>
                <span class="sidanav-collapsed-label">Vote for features</span>
              </a>
            </li>
          </div>
        </div>
      </ul>
    </div>
    <div id="" class="sidenav-res" [ngClass]="{
        'sidenav-hide': !collapsed || hideNavOnJobs,
        'sidenav-show': collapsed
      }">
      <ul class="sidenav-nav">
        <li class="sidenav-nav-item logo_space">
          <div class="logo-container" class="logo-container" [ngClass]="collapsed ? 'logo-container-collapsed' : ''">
            <a class="logo" (click)="toggleCollapsed()"><i class="bi bi-chevron-double-left"></i>
            </a>
          </div>
        </li>
        <div class="accordion accordion-PanelsStayOpen" id="accordionPanelsStayOpenExample">
          <!-- Jobs -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
              class="sidenav-nav-link navHov1">
              <span><i class="sidenav-icon bi bi-briefcase"></i></span>
              <span class="sideNav-colText">Jobs</span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Jobs -->
          <li routerLink="/school/jobs/headhunter" class="sidenav-nav-item">
            <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link navHov2">
              <span><i class="sidenav-icon bi bi-people"></i></span>
              <span class="sideNav-colText2">Headhunter</span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Jobs -->
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs/job-payment-history" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link navHov3">
              <span><i class="sidenav-icon bi bi-clock-history"></i></span>
              <span class="sideNav-colText3">Payment history</span>
            </a>
          </li>
          <!-- End of Jobs -->
          <!-- Jobs -->
          <!-- <li class="sidenav-nav-item">
    <a routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidenav-nav-link">
      <span><i class="sidenav-icon bi bi-people"></i></span>
    </a>
  </li> -->
          <!-- End of Jobs -->
          <!-- Jobs -->
          @if (!this.schoolProps.properties.is_booking_school) {
          <li class="sidenav-nav-item">
            <a routerLink="/school/jobs/job-subscription" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }" class="sidenav-nav-link navHov4">
              <span><i class="sidenav-icon bi bi-person-check"></i></span>
              <span class="sideNav-colText4">Upgrade your account</span>
            </a>
          </li>
          }
          <!-- End of Jobs -->
        </div>
      </ul>
    </div>
  </div>
  }
</div>
}
@if (sideNavHide) {
<div>
  <div class="sidenav-demo-show">
    <li class="sidenav-nav-item mt-20">
      <a class="sidenav-nav-link">
        <span><i class="sidenav-icon bi bi-calendar2-event"></i></span>
        <span class="sidanav-label">Test booking</span>
        <span class="sidanav-collapsed-label">Test booking</span>
      </a>
    </li>
    <li class="sidenav-nav-item mt-20 customNavDemo">
      <hr>
      <a class="sidenav-nav-link" (click)="stepTwo()">
        <span><i class="sidenav-icon bi bi-box-arrow-left"></i></span>
        <span class="sidanav-label">Exit Tutorial</span>
        <span class="sidanav-collapsed-label">Exit Tutorial</span>
      </a>
    </li>
  </div>
</div>
}